import { useEffect, useState } from "react";

/**
 * endOfMonthUTC:
 * Returns a Date representing the first instant of the next month in local TZ.
 * Countdown auto-renews at the end of each month.
 */
function endOfMonth(now = new Date()) {
  const y = now.getFullYear();
  const m = now.getMonth();
  const next = new Date(y, m + 1, 1, 0, 0, 0, 0);
  return next;
}

function diffParts(target) {
  const now = new Date();
  const ms = Math.max(0, target.getTime() - now.getTime());
  const s = Math.floor(ms / 1000);
  const days = Math.floor(s / 86400);
  const hours = Math.floor((s % 86400) / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;
  return { days, hours, minutes, seconds, ms };
}

export default function CountdownTimer({ className = "", compact = false }) {
  const [target, setTarget] = useState(endOfMonth());
  const [parts, setParts] = useState(diffParts(endOfMonth()));

  useEffect(() => {
    const id = setInterval(() => {
      const p = diffParts(target);
      if (p.ms <= 0) {
        const nt = endOfMonth();
        setTarget(nt);
        setParts(diffParts(nt));
      } else {
        setParts(p);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [target]);

  const pad = (n) => String(n).padStart(2, "0");

  const cells = [
    { label: "Days", value: pad(parts.days) },
    { label: "Hours", value: pad(parts.hours) },
    { label: "Min", value: pad(parts.minutes) },
    { label: "Sec", value: pad(parts.seconds) },
  ];

  return (
    <div
      data-testid="countdown-timer"
      className={`flex items-stretch ${compact ? "gap-2" : "gap-3"} ${className}`}
    >
      {cells.map((c) => (
        <div
          key={c.label}
          data-testid={`countdown-${c.label.toLowerCase()}`}
          className={`flex-1 min-w-0 rounded-xl border border-[#e5e7eb] bg-white/80 backdrop-blur-sm ${
            compact ? "px-2 py-2" : "px-3 py-3"
          } text-center shadow-[0_2px_8px_rgba(0,0,0,0.04)]`}
        >
          <div
            className={`font-heading font-semibold text-[#2f5a3f] tabular-nums ${
              compact ? "text-xl" : "text-2xl sm:text-3xl"
            }`}
          >
            {c.value}
          </div>
          <div className="eyebrow text-[#4b5563] mt-0.5">{c.label}</div>
        </div>
      ))}
    </div>
  );
}
